/* unplugin-vue-components disabled */import { render } from "./ImageViewer.vue?vue&type=template&id=306127fa&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"

import "./ImageViewer.vue?vue&type=style&index=0&id=306127fa&lang=scss"
import "./ImageViewer.vue?vue&type=style&index=1&id=306127fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306127fa"]])

export default __exports__